import { render, staticRenderFns } from "./TheTopbarNavbarAlerts.vue?vue&type=template&id=0b7335fa&scoped=true"
import script from "./TheTopbarNavbarAlerts.vue?vue&type=script&lang=js"
export * from "./TheTopbarNavbarAlerts.vue?vue&type=script&lang=js"
import style0 from "./TheTopbarNavbarAlerts.vue?vue&type=style&index=0&id=0b7335fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7335fa",
  null
  
)

export default component.exports